import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Loader from "../../components/Loader";
import { ROLES } from "../../constants/UserRoles";
import PrepGuidesMain from "../../components/orgAdmin/prepGuides/PrepGuidesMain";

function OrgAdminPrepGuides() {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="preparationGuides" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="preparationGuides"
            userRole={ROLES.org_admin}
            newTitle="Preparation Guides"
            noNavigate={true}
          />
          <PrepGuidesMain setLoading={setLoading} />
        </div>
      </div>
    </>
  );
}

export default OrgAdminPrepGuides;
